
/* System defined core library */
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from "rxjs";
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { State } from '../../../../shared/models/scheduling/state.model';
import { Country } from '../../../../shared/models/scheduling/country.model';
import { LocationSelector } from '../../../../shared/models/scheduling/locationSelector.model';

/* User defined models */
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

@Component({
    selector: 'app-region-selector',
    templateUrl: './region-selector.component.html'
})

export class RegionSelectorComponent implements OnInit, OnChanges {

    /* User defined private/public variables  */
    public regionFrm: FormGroup;
    public submitted: boolean;
    public selectedCountry: Country
    public selectedRegion: State
    public errorMessage: string = "";
    public countries: Country[];
    public regions: State[];


    /* Input-OutPut parameters decalartions */
    @Input() exam: Exam;
    @Output() getSelectedCountry: EventEmitter<Country> = new EventEmitter();
    @Output() getSelectedRegion: EventEmitter<State> = new EventEmitter();

    /* Service subscriptions */
    country$: Subscription;
    state$: Subscription;
    translateLanguage$: Subscription;

    /* Constructor declaration with required injected services */
    constructor(private selectedExamDetailService: SelectedExamDetailService,
        private schedulingApiService: SchedulingApiService,
        private fb: FormBuilder,
        private translate: TranslateService) {

        this.country$ = selectedExamDetailService.lpiCountry.subscribe(
            country => {
                this.selectedCountry = country;
            });

        this.state$ = selectedExamDetailService.lpiState.subscribe(
            state => {
                this.selectedRegion = state;
            });
        this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
            languageCode => {
                translate.use(languageCode);
            }
        );
        translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    }

    /* Initialize the component & call require methods when component loaded first time. */
    ngOnInit() {
        this.getCountries();

        this.regionFrm = this.fb.group({
            'selectCountry': new FormControl('', Validators.required),
            'selectRegion': new FormControl('', Validators.required),
        });
        if (this.selectedCountry != null &&
            this.selectedCountry != undefined) {
            this.getRegions(this.selectedCountry.id);
        }
    }

    /* Get list of countries from API */
    getCountries() {
        if (this.exam.id) {
            this.schedulingApiService.getCountriesByExam(this.exam.id).subscribe(
                countries => this.countries = countries,
                error => this.errorMessage = <any>error
            );
        }
    }

    /* Get list of regions from API */
    getRegions(countryCode: string) {
        this.schedulingApiService.getProvinces(countryCode).subscribe(
            regions => {
                if (regions != undefined && regions != null) {
                    this.regions = regions;
                } else {
                    this.regions = regions;
                    this.submitted = true;
                    this.selectedRegion = null;
                    let state: State = new State("-1", "Not Found");
                    this.getSelectedRegion.emit(state);
                }
            },
            error => this.errorMessage = <any>error
        );
    }

    /* Set changed region in shared service. */
    changeRegion(region: State): void {
        this.selectedRegion = region;
        this.getSelectedRegion.emit(region);
    }

    /* Set changed country in shared service. */
    changeCountry(country: Country): void {
        this.selectedRegion = null;
        this.selectedCountry = country;
        this.getSelectedCountry.emit(country);
        this.getRegions(this.selectedCountry.id);
    }
    /**
     * check if exam has chnaged, and retrive countries again 
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.exam) {
            const exam = changes.exam;
            // compare the values
            if (exam.currentValue && exam.previousValue) {
                if (exam.currentValue.id !== exam.previousValue.id) {
                    this.selectedCountry = null;
                    this.getCountries();
                }
            }
        }
    }
}
